import React from 'react';
import { Form, Button } from 'antd';
import { useSelector } from 'react-redux';

// https://ant.design/components/form/#components-form-demo-basic
const FormButton = ({
  requestInProgress,
  submitKey,
  submitOnClick = false,
  children,
  disabled = false,
  onClick,
  ...rest
}) => {
  const isFetching = useSelector((state) => state.fetch.isFetching);

  return (
    <Form.Item>
      <Button
        type="primary"
        htmlType={submitOnClick ? 'submit' : 'button'}
        onClick={(e) => {
          if (!submitOnClick) {
            e.preventDefault();
          }

          if (onClick) onClick(e);
        }}
        disabled={disabled || isFetching}
        {...rest}
      >
        {children}
      </Button>
    </Form.Item>
  );
};

export default FormButton;
